export default function ManifestoPanel() {
  return (
    <section className="panel manifesto" data-side="bottom" id="belief" aria-labelledby="belief-heading">
      <div className="manifesto-rings" aria-hidden="true" data-parallax="0.55">
        <span />
        <span />
        <span />
      </div>
      <h2 id="belief-heading" className="stamp" data-reveal style={{ marginBottom: 26 }}>
        03 — Our belief
      </h2>
      <p className="manifesto-text" data-words>
        Giving should be quiet, considered and durable. We hold each decision to the same
        standard: does this <em className="accent">strengthen</em> something that will outlast
        us?
      </p>
    </section>
  );
}